var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"titleTop"},[_c('div',{staticClass:"TitleModule"},[_c('img',{attrs:{"src":_vm.titleSrc,"alt":""}}),_c('div',[_vm._v(_vm._s(_vm.titleName))])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }